import React from "react";
import { PostHogProvider } from "@posthog/react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "../app/store";
import { env } from "../env";

const posthogOptions = {
  api_host: env.REACT_APP_VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2026-01-30",
};

/** Proveedor principal que envuelve la app con Redux, PostHog y React Router. */
export function AppProviders({ children }) {
  return (
    <Provider store={store}>
      <React.StrictMode>
        <PostHogProvider
          apiKey={env.REACT_APP_VITE_PUBLIC_POSTHOG_PROJECT_TOKEN}
          options={posthogOptions}
        >
          <BrowserRouter>{children}</BrowserRouter>
        </PostHogProvider>
      </React.StrictMode>
    </Provider>
  );
}